import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import MatchModelsSearch from "./components/MatchModelsSearch";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Switch>
          <Route component={MatchModelsSearch} />
        </Switch>
      </div>
    </BrowserRouter>
  );
}

export default App;
